import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { ILinkProps, IReverbHeaderMenuSectionProps } from './reverb_header_menu_data';
import { RCTextWithIcon, RCFlex, RCTag, useMediaQuery } from '@reverbdotcom/cadence/components';

export function ReverbHeaderMenuLink({
  path,
  text,
  hide,
  logOut,
  onClick,
  newFeature,
}: ILinkProps) {
  const isTablet = useMediaQuery('tablet');
  const isMobile = useMediaQuery('mobile');

  if (hide) { return null; }

  if (logOut) {
    return (
      <li>
        <a
          href={path}
          data-method="delete"
          className="size-80 opacity-70"
        >
          {text}
        </a>
      </li>
    );
  }

  if (newFeature) {
    return (
      <li>
        <RCFlex justify={(isTablet || isMobile) ? 'start' : 'space-between'} align="center">
          <CoreLink to={path} onClick={onClick}>
            {text}
          </CoreLink>

          <RCTag variant="highlight" small={false}>
            {I18n.t('discovery.reverbHeader.userMenu.newFeature')}
          </RCTag>
        </RCFlex>
      </li>
    );
  }

  return (
    <li>
      <CoreLink to={path} onClick={onClick}>
        {text}
      </CoreLink>
    </li>
  );
}

export default function ReverbHeaderMenuSection({ title, links, onClick, icon = undefined }: IReverbHeaderMenuSectionProps) {
  return (
    <>
      <div className="reverb-header__menu__user-menu__header">
        {icon && (
          <RCFlex align="center" justify="start" gap="0">
            <RCTextWithIcon icon={icon} placement="left">
              {title}
            </RCTextWithIcon>
          </RCFlex>
        )}

        {!icon && title}
      </div>
      <ul>
        {links.map(link => (
          <ReverbHeaderMenuLink
            key={link.key}
            path={link.path}
            text={link.text}
            logOut={link.logOut}
            hide={link.hide}
            onClick={onClick}
            newFeature={link.newFeature}
          />
        ))}
      </ul>
    </>
  );
}
